import axios from 'axios';
import Cookies from 'js-cookie';

export const http = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL || 'https://api.rajivwilliams.com', // your backend
  
  // baseURL: 'http://192.168.0.8:8088',
  
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
  },
});

// Add request interceptor
http.interceptors.request.use((config) => {
  const token = Cookies.get('access_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

// Add response interceptor
http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    if (err.message === 'Network Error') {
      alert('Network Error: Check your connection or backend availability');
    } else if (err.response?.status === 401) {
      Cookies.remove('access_token');
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

// ✅ Optional: create a helper function for WhatsApp proxy request
// export const sendWhatsAppProxy = (payload: any) => {
//   // Calls backend /send-whatsapp route instead of AiSensy directly
//   return http.post('/send-whatsapp', payload);
// };
